import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from 'reactstrap';
import ActionButton from '../../../../../Components/Common/ActionButton';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const EMPTY_FORM = {
  otCounter: '',
  otOption: '',
  volumeCounter: '',
  ddrCounterFrom: null,
  ddrCounterTo: null,
  incotermsCounter: [],
};

const INCOTERM_OPTIONS = ['FOB', 'DAP', 'CFR'];

const CargoCounterModal = ({
  isOpen,
  cargo,
  currentCounter,
  onClose,
  onSubmit,
}) => {
  const [form, setForm] = useState(EMPTY_FORM);

  useEffect(() => {
    if (isOpen) {
      setForm(
        currentCounter
          ? {
              otCounter: currentCounter.otCounter ?? '',
              otOption: currentCounter.otOption ?? '',
              volumeCounter: currentCounter.volumeCounter ?? '',
              ddrCounterFrom: currentCounter.ddrCounterFrom
                ? new Date(currentCounter.ddrCounterFrom)
                : null,
              ddrCounterTo: currentCounter.ddrCounterTo
                ? new Date(currentCounter.ddrCounterTo)
                : null,
              incotermsCounter: currentCounter.incotermsCounter ?? [],
            }
          : EMPTY_FORM
      );
    }
  }, [isOpen, currentCounter]);

  const set = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const toggleIncoterm = term => {
    setForm(prev => {
      const list = prev.incotermsCounter.includes(term)
        ? prev.incotermsCounter.filter(t => t !== term)
        : [...prev.incotermsCounter, term];
      return { ...prev, incotermsCounter: list };
    });
  };

  const handleSubmit = () => {
    onSubmit({
      ...form,
      ddrCounterFrom: form.ddrCounterFrom?.toISOString() ?? null,
      ddrCounterTo: form.ddrCounterTo?.toISOString() ?? null,
    });
    onClose();
  };

  const cargoLabel = cargo ? `${cargo.plant} – ${cargo.unit}` : '';

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered size='lg'>
      <ModalHeader toggle={onClose}>Counter — {cargoLabel}</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>OT Counter</Label>
              <Input
                type='select'
                value={form.otCounter}
                onChange={e => set('otCounter', e.target.value)}
              >
                <option value=''>— Pilih —</option>
                <option value='5%'>5%</option>
                <option value='10%'>10%</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>OT Option</Label>
              <Input
                type='select'
                value={form.otOption}
                onChange={e => set('otOption', e.target.value)}
              >
                <option value=''>— Pilih —</option>
                <option value='Buyer Option'>Buyer Option</option>
                <option value='Seller Option'>Seller Option</option>
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Volume Counter</Label>
              <Input
                type='number'
                min={0}
                value={form.volumeCounter}
                onChange={e => set('volumeCounter', e.target.value)}
                placeholder='Masukkan volume'
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>DDR Counter — From</Label>
              <DatePicker
                selected={form.ddrCounterFrom}
                onChange={date => set('ddrCounterFrom', date)}
                dateFormat='dd MMM yyyy'
                className='form-control'
                placeholderText='Pilih tanggal dari'
                wrapperClassName='d-block'
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>DDR Counter — To</Label>
              <DatePicker
                selected={form.ddrCounterTo}
                onChange={date => set('ddrCounterTo', date)}
                dateFormat='dd MMM yyyy'
                className='form-control'
                placeholderText='Pilih tanggal sampai'
                wrapperClassName='d-block'
                minDate={form.ddrCounterFrom}
              />
            </FormGroup>
          </Col>
        </Row>
        <FormGroup>
          <Label>Incoterms Counter</Label>
          <div className='d-flex gap-4 mt-1'>
            {INCOTERM_OPTIONS.map(term => (
              <div className='form-check' key={term}>
                <Input
                  type='checkbox'
                  className='form-check-input'
                  id={`inco-counter-${term}`}
                  checked={form.incotermsCounter.includes(term)}
                  onChange={() => toggleIncoterm(term)}
                />
                <Label
                  className='form-check-label'
                  for={`inco-counter-${term}`}
                >
                  {term}
                </Label>
              </div>
            ))}
          </div>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <ActionButton
          variant='secondary'
          icon='ri-close-line'
          onClick={onClose}
        >
          Cancel
        </ActionButton>
        <ActionButton
          variant='primary'
          icon='ri-send-plane-line'
          onClick={handleSubmit}
        >
          Submit
        </ActionButton>
      </ModalFooter>
    </Modal>
  );
};

export default CargoCounterModal;
